import moment from 'moment';

export default {
	getMailBoxes: state => {
		if (state.mailBoxes) {
			return state.mailBoxes.sort((u1, u2) => {
				if (moment(u1.createdAt).isSameOrBefore(u2.createdAt)) return 1;
				else return -1;
			});
		} else state.mailBoxes;
	},
	getMailBox: state => state.mailBox,
};
